export const AppSettings = {
    ApiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? '',
    YouVerify: {
        Pmk: process.env.REACT_APP_YOU_VERIFY_PMK ?? '',
        SandboxMode: process.env.REACT_APP_YOU_VERIFY_SANDBOX_MODE ?? false
    },
    KaziDemoUrl: process.env.REACT_APP_KAZI_DEMO_URL ?? '',
    WebsocketUrl: process.env.REACT_APP_WEBSOCKET_URL ?? '',
    EnableJobsMarketplace: process.env.REACT_APP_ENABLE_JOBS_MARKETPLACE ?? false,
    StreamChatApiKey: process.env.REACT_APP_STREAM_CHAT_API_KEY ?? '',
    Sentry:{
        Dsn: process.env.REACT_APP_SENTRY_DSN ?? '',
        SessionSampleRate: Number(process.env.REACT_APP_SENTRY_REPLAYS_ON_SESSION_SAMPLE_RATE ?? 0.1),
        ErrorsSampleRate: Number(process.env.REACT_APP_SENTRY_REPLAY_ON_ERRORS_SAMPLE_RATE ?? 1.0),
    },
    Stripe: {
        PublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? '',
        MonthlyId: process.env.REACT_APP_STRIPE_MONTHLY_ID ?? '',
        AnnualId: process.env.REACT_APP_STRIPE_ANNUAL_ID ?? '',
        MonthlyAfricaId: process.env.REACT_APP_STRIPE_MONTHLY_AFRICA_ID ?? '',
        AnnualAfricaId: process.env.REACT_APP_STRIPE_ANNUAL_AFRICA_ID ?? ''
    },
    SupportEmail: process.env.REACT_APP_KAZI_SUPPORT_EMAIL ?? '',
    NodeEnvironment: process.env.REACT_APP_NODE_ENVIRONMENT ?? process.env.NODE_ENV,
    Veriff: {
        Host: process.env.REACT_APP_VERIFF_HOST ?? '',
        ApiKey: process.env.REACT_APP_VERIFF_API_KEY ?? ''
    }
}